const ALL_ACTIONS = {
    SET_STATE: "SET_STATE",
    SET_NEW_PROSPECT: "SET_NEW_PROSPECT",
    UPDATE_PROSPECT_LIST: "UPDATE_PROSPECT_LIST"
}

export default ALL_ACTIONS